import { render, staticRenderFns } from "./LockDeviceSwitcher.vue?vue&type=template&id=33d8da11&"
import script from "./LockDeviceSwitcher.vue?vue&type=script&lang=js&"
export * from "./LockDeviceSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports